export default __webpack_public_path__ + "static/media/947.930050c8.png";